import { useReducer } from "react";
import { useContext } from "react";
import { createContext } from "react";

export const AppContext = createContext();

const initialState = {
	lang: "se",
	isUserLogin: localStorage.user ? true : false,
	userUnits: [],
	userName: "",
	isAdmin: false,
};

export const CHANGE_LANG = "CHANGE_LANG";
export const USER_LOGIN = "USER_LOGIN";
export const USER_UNITS = "USER_UNITS";
export const SET_USER_NAME = "SET_USER_NAME";
export const SET_IS_ADMIN = "SET_IS_ADMIN";

export function changeLang(lang) {
	return { type: CHANGE_LANG, lang };
}

export function userLogin(isUserLogin) {
	return { type: USER_LOGIN, isUserLogin };
}

export function userUnits(userUnits) {
	return { type: USER_UNITS, userUnits };
}

export function setUserName(userName) {
	return { type: SET_USER_NAME, userName };
}

export function setIsAdmin(isAdmin) {
	return { type: SET_IS_ADMIN, isAdmin };
}

export function AppReducer(state, action) {
	switch (action.type) {
		case CHANGE_LANG:
			return { ...state, lang: action.lang };
		case USER_LOGIN:
			return { ...state, isUserLogin: action.isUserLogin };
		case USER_UNITS:
			return { ...state, userUnits: action.userUnits };
		case SET_USER_NAME:
			return { ...state, userName: action.userName };
		case SET_IS_ADMIN:
			return { ...state, isAdmin: action.isAdmin };
		default:
			return state;
	}
}

function AppProvider(props) {
	const [items, dispatch] = useReducer(AppReducer, initialState);
	const appData = { items, dispatch };
	return <AppContext.Provider value={appData} {...props} />;
}

function useAppContext() {
	return useContext(AppContext);
}

export { AppProvider, useAppContext };
